import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Footer from "../../common/Footer";
import { useNavigate } from "react-router";
// import { getAllCourses } from "./coursesApi";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../common/debounce";
import SearchIcon from "@mui/icons-material/Search";
// import CompnayInforamtion from "./modal";
import {
  getAllCompanypRODUCTS,
  getCompanypRODUCTS,
  interestedCompanyEnquiries,
} from "../WhiteLabels/whitelabelApi";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { routePath } from "../../constants/routePath";
import { setchangeRoll } from "../../app/store/reducer";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { getAllConsultants } from "../myCOnsultant/consultantAPI";

export default function ConsultantsList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [allCourse, setAllCourse] = useState();
  const searchValue = useSelector((state) => state.reducer.searchValue);
  const [searchhere, setSearchHere] = useState("");
  const debouncedSearchHere = useDebounce(searchhere, 500);
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const [modalData, setModalData] = useState();
  const [viewType, setViewType] = useState("");
  const [open, setOpen] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getCourses = async () => {
    const payload = {
      billerId: 0,
      search: debouncedSearchHere || debouncedSearchValue,
    };

    // console.log("bbbb", billerId);

    getAllConsultants(payload, (data) => {
      // console.log("Courses- ", data.data.data.list);
      setAllCourse(data.data.data.list);
    });
  };
  useEffect(() => {
    getCourses();
  }, [debouncedSearchValue, debouncedSearchHere]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/\s/g, "-");

  const token = sessionStorage.getItem("smbToken");

  const Applyinterested = async (id) => {
    // console.log("bbbb", billerId);
    if (!token) {
      Swal.fire({
        text: "Please login",
        icon: "error",
        ...swalAlertPopProps,
      }).then((result) => {
        navigate(routePath.CUSTOMERLOGIN);
      });

      return;
    }

    interestedCompanyEnquiries({ companyProductId: id }, (data) => {
      getCourses();
    });
  };
  return (
    <>
      <Box
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: { xs: 2, sm: 2, md: 5, lg: 4 },
            pt: { xs: 2, sm: 3, md: 5 },
            pb: 2,
            backgroundColor: "#fff",
            position: "relative",
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              // justifyContent: "space-between",
              gap:2,
              alignItems: "center",
            }}
          >
            <Box
              onClick={() => navigate("/")}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
            </Box>

            <Typography
              sx={{
                fontSize: { xs: 18, sm: 22, md: 28 },
                fontWeight: 500,
              }}
            >
              Consultants
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            px: { xs: 2, sm: 2, md: 5, lg: 4 },
          }}
        >
          <Grid
            container
            //   spacing={{ xs: 2, sm: 1, md: 2, lg: 2 }}
            rowSpacing={{ xs: 2, sm: 2, md: 2, lg: 2 }} // vertical gap
            columnSpacing={{xs:3,sm:3,md:3,lg:1,}}
            sx={{
              position: "relative",
              zIndex: 1,
            }}
          >
            {allCourse?.map((item) => {
              return (
                <Grid item xs={12} sm={6} md={6} lg={4} key={item.id}>
                  <Box
                    onClick={() => {
                      navigate(`/consultantDetails/${item.id}`);

                      sessionStorage.setItem("mode", "customer");
                      dispatch(setchangeRoll("customer"));
                    }}
                    sx={{
                      backgroundColor: "#EAEAFF",
                      borderRadius: "3px",
                      p: 2,
                      boxShadow: "0px 4px 4px 0px #00000040",
                      cursor: "pointer",
                      // position: "relative",
                    }}
                  >
                    <Grid container alignItems="center">
                      <Grid
                        container
                        //   mb={2}
                        spacing={{ lg: 10, md: 8, sm: 5, xs: 0 }}
                        alignItems="center"
                        justifyContent="center"
                      >
                        {/* Logo */}

                        <Grid item mb={2} xs={12} sm={3}>
                          {item?.logo && (
                            <Box
                              component="img"
                              src={item?.logo}
                              alt="image"
                              sx={{
                                width: {
                                  xs: "100%",
                                  sm: 80,
                                  md: 100,
                                  lg: 100,
                                  xl: 110,
                                },
                                height: {
                                  xs: 180,
                                  sm: 90,
                                  md: 100,
                                  lg: 100,
                                  xl: 110,
                                },
                                maxHeight: 200,
                                maxWidth: 200,
                                objectFit: "cover",
                                borderRadius: 2,
                              }}
                            />
                          )}
                        </Grid>

                        {/* Job Details */}
                        <Grid item xs={12} sm={9}>
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "16px",
                                sm: "18px",
                                md: "22px",
                                lg: "24px",
                              },
                              fontWeight: 600,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: 1.4,
                              height: "1.4em",
                            }}
                          >
                            {item?.consultantName}
                          </Typography>
                          {/* Company Name */}
                          <Typography
                            sx={{
                              fontSize: { xs: "10px", sm: "12px", md: "14px" },
                              fontWeight: 400,
                              // mt: 0.5,
                              color: "#494949",
                            }}
                          >
                            Consultant Id: {item?.consultantId}
                          </Typography>

                          {/*  Franchise Title */}
                          <Typography
                            sx={{
                              fontSize: { xs: "13px", sm: "13px", md: "15px" },
                              fontWeight: 600,
                              mt: 0.5,
                              color: "#000000",
                            }}
                          >
                            Company Name
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: "13px", sm: "13px", md: "15px" },
                              fontWeight: 500,
                              mt: 0.5,
                              color: "#000000",
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: 1.4,
                              height: "1.4em",
                            }}
                          >
                            {item?.companyName}
                          </Typography>

                          <Box
                            sx={{
                              display: "flex",
                              // justifyContent: "center",
                              // alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "13px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 600,
                                mt: 0.5,
                                color: "#000000",
                              }}
                            >
                              City: &nbsp;
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "13px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                                mt: 0.5,
                                color: "#000000",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                lineHeight: 1.4,
                                height: "1.4em",
                              }}
                            >
                              {item?.city}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "end",
                              p: { sm: 1, xs: 0 },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "10px",
                                  sm: "12px",
                                  md: "13px",
                                },
                                color: "#494949",
                              }}
                            >
                              Posted On {formatDate(item?.createdDate)}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>

      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </>
  );
}
